import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import CourseClaudeCode101 from "@/pages/CourseClaudeCode101";
import ClaudeCodeSetup from "@/pages/ClaudeCodeSetup";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import LabCatalog from "@/pages/LabCatalog";
import LabDetail from "@/pages/LabDetail";
import Subscription from "@/pages/Subscription";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Verify from "@/pages/Verify";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Contact from "@/pages/Contact";
import VerifyEmail from "@/pages/VerifyEmail";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";

function App() {
  useEffect(() => {
    try {
      if (sessionStorage.getItem("ilfal_visit_tracked")) return;
      sessionStorage.setItem("ilfal_visit_tracked", "1");
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: window.location.pathname, timezone: tz, language: navigator.language || "" }),
      }).catch(() => {});
    } catch (e) { /* no-op */ }
  }, []);

  return (
    <div className="App min-h-screen flex flex-col bg-zinc-50 dark:bg-[#050505] transition-colors duration-300">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify/:verificationId" element={<Verify />} />
                <Route path="/courses/claude-code-101" element={<CourseClaudeCode101 />} />
                <Route path="/docs/claude-code-setup" element={<ClaudeCodeSetup />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />

                <Route path="/verify-email" element={<ProtectedRoute allowUnverified={true}><VerifyEmail /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/labs" element={<ProtectedRoute><LabCatalog /></ProtectedRoute>} />
                <Route path="/labs/:slug" element={<ProtectedRoute><LabDetail /></ProtectedRoute>} />
                <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
                <Route path="/subscription/success" element={<ProtectedRoute><SubscriptionSuccess /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly={true}><Admin /></ProtectedRoute>} />
              </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
